import Vue from 'vue';
import VueToast from './Toast';
import {removeNode} from '../../common/utils/dom';
var defaultOptions = {
    text: '',
    value: true,
    duration: 2000,
    type: 'text',
    icon: ''
};

function transformOptions(options) {
    return Object.assign({}, options);
}

function createInstance() {
    var ToastConstructor = Vue.extend(VueToast);
    var toast = new ToastConstructor({
        el: document.createElement('div')
    });
    toast.$on('input', function(value) {
        toast.value = value;
    });
    return toast;
}

function Toast(opt) {
    var options = Object.assign(Object.assign({}, defaultOptions), opt);
    var toast = createInstance();
    Object.assign(toast, transformOptions(options));

    var hide = function hide(toast) {
        toast.$emit('change', false);
        removeNode(toast.$overlay.$el);
        removeNode(toast.$el);
    };

    clearTimeout(toast.timer);

    if (options.duration > 0) {
        toast.timer = setTimeout(function() {
            hide(toast);
        }, options.duration);
    }

    var component = toast.$mount();
    document.body.appendChild(component.$el);
    return {
        close: function close() {
            hide(toast);
        }
    };
}

Toast.install = function(Vue) {
    Vue.use(VueToast);
    Vue.prototype.$toast = Toast;
};

Toast.success = function() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '操作成功';
    var opt = arguments.length > 1 ? arguments[1] : undefined;
    return Toast(
        Object.assign(
            {
                text: text,
                type: 'success'
            },
            opt
        )
    );
};

Toast.fail = function() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '失败';
    var opt = arguments.length > 1 ? arguments[1] : undefined;
    return Toast(
        Object.assign(
            {
                text: text,
                type: 'fail'
            },
            opt
        )
    );
};

Toast.loading = function() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '加载中';
    var opt = arguments.length > 1 ? arguments[1] : undefined;
    return Toast(
        Object.assign(
            {
                text: text,
                type: 'loading'
            },
            opt
        )
    );
};

export default Toast;
